import { render, staticRenderFns } from "./setDate.vue?vue&type=template&id=64f01ab4&scoped=true"
import script from "./setDate.vue?vue&type=script&lang=js"
export * from "./setDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f01ab4",
  null
  
)

export default component.exports